import { Component } from '@angular/core';
import { ProjectDataService } from '@core/services/project-data/project-data.service';
import { CountriesService } from '@core/services/countries/countries.service';
import { GeoData } from '@core/models/country.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-shared-restricted-countries',
  templateUrl: './restricted-countries.component.html',
  styleUrls: ['./restricted-countries.component.scss']
})
export class RestrictedCountriesComponent {
  brandName = null;
  project = null;

  constructor(
    private projectDataService: ProjectDataService,
    private countriesService: CountriesService,
    private router: Router,
  ) {
    this.project = this.projectDataService.get('project');
    this.brandName = this.projectDataService.get('brand_name_short');

    this.countriesService.visitorCountry$.subscribe((geoData: GeoData) => {
      if (geoData) {
        if (!geoData.restricted) {
          this.router.navigate(['/']);
        }
      }
    });
  }

}
